module.exports = __webpack_public_path__ + "static/media/Silverbojen.ae3088b3.png";